import React from "react";

export default function Gallery () {
    return(
        <div className="root">
            hericles
        </div>
    )
}